import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import QRCode from 'qrcode.react';
import Moment from 'react-moment';
import Barcode from '../comum/Barcode';

export class NotaFiscalCte extends Component {

    exibeBarcode(chaveCte) {
        if (chaveCte) {
            return (
                <React.Fragment>
                    <Barcode value={chaveCte} format='CODE128' />
                </React.Fragment>
            );
        }
        return '';
    }

    exibeQrCode(url) {
        if (url) {
            return (
                <QRCode style={{ width: 130, height: 130 }} value={url} />
            );
        }
        return '';
    }

    exibeParte1() {
        const { encomenda, empresaSelecionada } = this.props;
        const chaveCte = encomenda.ultimoHistoricoEmissaoCte && encomenda.ultimoHistoricoEmissaoCte.chaveCte;
        const urlQRCode = encomenda.ultimoHistoricoEmissaoCte && encomenda.ultimoHistoricoEmissaoCte.urlQRCode;
        const endereco = empresaSelecionada.endereco;

        return (
            <div className='dacte-header'>
                <div className='dacte-header-empresa'>
                    <div className='dacte-empresa-nome'>{empresaSelecionada.nomeFantasia}</div>
                    {endereco && (
                        <>
                            <div>{endereco.logradouro}{endereco.complemento ? `, ${endereco.complemento}` : ''}</div>
                            <div>{endereco.bairro ? `${endereco.bairro} - ` : ''}{endereco.nomeCidade} - {endereco.cep}</div>
                            <div>Fone/Fax: {empresaSelecionada.fone || ''}</div>
                        </>
                    )}
                    <div>CNPJ/CPF: <strong>{empresaSelecionada.cnpj}</strong> &nbsp; Insc.Estadual: {empresaSelecionada.inscricaoEstadual}</div>
                </div>

                <div className='dacte-header-center'>
                    <div className='dacte-titulo-block'>
                        <div className='dacte-titulo-nome'>DACTE</div>
                        <div>Documento Auxiliar do Conhecimento</div>
                        <div>de Transporte Eletrônico</div>
                    </div>
                    <div className='dacte-campos-block'>
                        <div className='dacte-campo-item'>
                            <div className='dacte-field-label'>MODELO</div>
                            <div>{encomenda.modelo}</div>
                        </div>
                        <div className='dacte-campo-item'>
                            <div className='dacte-field-label'>SÉRIE</div>
                            <div>{encomenda.serieCte}</div>
                        </div>
                        <div className='dacte-campo-item'>
                            <div className='dacte-field-label'>NÚMERO</div>
                            <div>{encomenda.numeroCte}</div>
                        </div>
                        <div className='dacte-campo-item'>
                            <div className='dacte-field-label'>FL</div>
                            <div>1/1</div>
                        </div>
                        <div className='dacte-campo-data'>
                            <div className='dacte-field-label'>DATA E HORA DE EMISSÃO</div>
                            <div>{encomenda.dataEmissaoCte
                                ? <Moment format='DD/MM/YYYY HH:mm:ss'>{encomenda.dataEmissaoCte}</Moment>
                                : ''}
                            </div>
                        </div>
                        <div className='dacte-campo-item'>
                            <div className='dacte-field-label'>INSC. SUFRAMA DO DEST.</div>
                            <div></div>
                        </div>
                    </div>
                    <div className='dacte-tipo-block'>
                        <div className='dacte-tipo-item'>
                            <div className='dacte-field-label'>TIPO CTE</div>
                            <div>Normal</div>
                        </div>
                        <div className='dacte-tipo-item'>
                            <div className='dacte-field-label'>TIPO DO SERVIÇO</div>
                            <div>{encomenda.tipoServicoCte && encomenda.tipoServicoCte.valor}</div>
                        </div>
                        <div className='dacte-tipo-item'>
                            <div className='dacte-field-label'>TOMADOR DO SERVIÇO</div>
                            <div>Outros</div>
                        </div>
                        <div className='dacte-tipo-item'>
                            <div className='dacte-field-label'>INDICADOR DO CT-E GLOBALIZADO</div>
                            <div>SIM &nbsp;&nbsp; X &nbsp; NÃO</div>
                        </div>
                    </div>
                </div>

                <div className='dacte-header-right'>
                    <div className='dacte-modal-block'>
                        <div className='dacte-modal-item'>
                            <div className='dacte-field-label'>MODAL</div>
                            <div className='dacte-modal-valor'>Rodoviário</div>
                        </div>
                        <div className='dacte-modal-item'>
                            <div className='dacte-field-label'>MD</div>
                            <div className='dacte-modal-valor'>{encomenda.numeroCte}</div>
                        </div>
                    </div>
                    <div className='dacte-barcode-block'>
                        {chaveCte ? this.exibeBarcode(chaveCte) : ''}
                    </div>
                    <div className='dacte-qrcode-block'>
                        {chaveCte ? this.exibeQrCode(urlQRCode || chaveCte) : ''}
                    </div>
                </div>
            </div>
        );
    }

    exibeChaveAcesso() {
        const chaveCte = this.props.encomenda.ultimoHistoricoEmissaoCte && this.props.encomenda.ultimoHistoricoEmissaoCte.chaveCte;
        return (
            <div className='dacte-chave-acesso'>
                <div className='dacte-chave-link'>
                    Consulta de autenticidade no portal nacional do CT-e, no site da Sefaz Autorizadora, ou em http://www.cte.fazenda.gov.br
                </div>
                <div className='dacte-chave-valor'>{chaveCte}</div>
            </div>
        );
    }

    exibeProtocoloECfop() {
        const { encomenda } = this.props;
        const hist = encomenda.ultimoHistoricoEmissaoCte || {};
        const endRem = encomenda.enderecoRemetente || {};
        const endDest = encomenda.enderecoDestinatario || {};

        return (
            <>
                <div className='dacte-protocolo-row'>
                    <div className='dacte-protocolo-item'>
                        <div className='dacte-field-label'>PROTOCOLO DE AUTORIZAÇÃO DE USO</div>
                        <div className='dacte-protocolo-valor'>
                            {hist.protocolo || hist.numeroProtocolo || ''}
                            {hist.dataAutorizacao ? ' - ' : ''}
                            {hist.dataAutorizacao
                                ? <Moment format='DD/MM/YYYY HH:mm:ss'>{hist.dataAutorizacao}</Moment>
                                : ''}
                        </div>
                    </div>
                </div>
                <div className='dacte-cfop-prestacao-row'>
                    <div className='dacte-cfop-item'>
                        <div className='dacte-field-label'>CFOP - NATUREZA DA PRESTAÇÃO</div>
                        <div>{encomenda.naturezaOperacaoCte && encomenda.naturezaOperacaoCte.valor}</div>
                    </div>
                    <div className='dacte-inicio-item'>
                        <div className='dacte-field-label'>INÍCIO DA PRESTAÇÃO</div>
                        <div>{endRem.codigoCidade ? `${endRem.codigoCidade} - ` : ''}{endRem.localidade} - {endRem.uf}</div>
                    </div>
                    <div className='dacte-termino-item'>
                        <div className='dacte-field-label'>TÉRMINO DA PRESTAÇÃO</div>
                        <div>{endDest.codigoCidade ? `${endDest.codigoCidade} - ` : ''}{endDest.localidade} - {endDest.uf}</div>
                    </div>
                </div>
            </>
        );
    }

    exibePessoaSection(label, pessoa, endereco) {
        const p = pessoa || {};
        const e = endereco || {};
        return (
            <div className='dacte-pessoa-section'>
                <div className='dacte-pessoa-row1'>
                    <span className='dacte-pessoa-label'>{label}</span>
                    <span className='dacte-pessoa-nome'>{p.nome || p.nomeFantasia || ''}</span>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>ENDEREÇO</span>
                        &nbsp;{e.logradouro || ''}{e.bairro ? ` ${e.bairro}` : ''}
                    </span>
                </div>
                <div className='dacte-pessoa-row2'>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>MUNICÍPIO</span>
                        &nbsp;{e.localidade || e.nomeCidade || ''} - {e.uf || ''}
                    </span>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>CEP</span>
                        &nbsp;{e.cep || ''}
                    </span>
                </div>
                <div className='dacte-pessoa-row3'>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>CNPJ/CPF</span>
                        &nbsp;{p.cpfCnpj || ''}
                    </span>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>INSCRIÇÃO ESTADUAL</span>
                        &nbsp;{p.inscEstadual || 'ISENTO'}
                    </span>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>PAÍS</span>
                        &nbsp;Brasil
                    </span>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>FONE</span>
                        &nbsp;{p.telefone || '-'}
                    </span>
                </div>
            </div>
        );
    }

    exibeExpedidorRecebedor() {
        return (
            <div className='dacte-expedidor-recebedor-row'>
                <div className='dacte-expedidor-section dacte-pessoa-section'>
                    <div className='dacte-pessoa-row1'>
                        <span className='dacte-pessoa-label'>EXPEDIDOR</span>
                        <span className='dacte-pessoa-campo'>
                            <span className='dacte-field-label'>ENDEREÇO</span> ,
                        </span>
                    </div>
                    <div className='dacte-pessoa-row2'>
                        <span className='dacte-pessoa-campo'>
                            <span className='dacte-field-label'>MUNICÍPIO</span> -
                        </span>
                        <span className='dacte-pessoa-campo'>
                            <span className='dacte-field-label'>CEP</span>
                        </span>
                    </div>
                    <div className='dacte-pessoa-row3'>
                        <span className='dacte-pessoa-campo'><span className='dacte-field-label'>CNPJ/CPF</span></span>
                        <span className='dacte-pessoa-campo'><span className='dacte-field-label'>INSCRIÇÃO ESTADUAL</span></span>
                        <span className='dacte-pessoa-campo'><span className='dacte-field-label'>PAÍS</span></span>
                        <span className='dacte-pessoa-campo'><span className='dacte-field-label'>FONE</span></span>
                    </div>
                </div>
                <div className='dacte-recebedor-section dacte-pessoa-section'>
                    <div className='dacte-pessoa-row1'>
                        <span className='dacte-pessoa-label'>RECEBEDOR</span>
                        <span className='dacte-pessoa-campo'>
                            <span className='dacte-field-label'>ENDEREÇO</span> ,
                        </span>
                    </div>
                    <div className='dacte-pessoa-row2'>
                        <span className='dacte-pessoa-campo'>
                            <span className='dacte-field-label'>MUNICÍPIO</span> -
                        </span>
                        <span className='dacte-pessoa-campo'>
                            <span className='dacte-field-label'>CEP</span>
                        </span>
                    </div>
                    <div className='dacte-pessoa-row3'>
                        <span className='dacte-pessoa-campo'><span className='dacte-field-label'>CNPJ/CPF</span></span>
                        <span className='dacte-pessoa-campo'><span className='dacte-field-label'>INSCRIÇÃO ESTADUAL</span></span>
                        <span className='dacte-pessoa-campo'><span className='dacte-field-label'>PAÍS</span></span>
                        <span className='dacte-pessoa-campo'><span className='dacte-field-label'>FONE</span></span>
                    </div>
                </div>
            </div>
        );
    }

    exibeTomador() {
        const { encomenda } = this.props;
        const tomador = encomenda.tomador || encomenda.destinatario || {};
        const end = encomenda.enderecoTomador || encomenda.enderecoDestinatario || {};
        return (
            <div className='dacte-tomador-section'>
                <div className='dacte-tomador-row1'>
                    <span className='dacte-pessoa-label'>TOMADOR DO SERVIÇO</span>
                    <span className='dacte-pessoa-nome'>{tomador.nome || tomador.nomeFantasia || ''}</span>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>MUNICÍPIO</span>
                        &nbsp;{end.localidade || end.nomeCidade || ''}
                    </span>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>UF</span>
                        &nbsp;{end.uf || ''}
                    </span>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>CEP</span>
                        &nbsp;{end.cep || ''}
                    </span>
                </div>
                <div className='dacte-tomador-row2'>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>ENDEREÇO</span>
                        &nbsp;{end.logradouro || ''}{end.bairro ? ` - ${end.bairro}` : ''}
                    </span>
                </div>
                <div className='dacte-pessoa-row3'>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>CNPJ/CPF</span>
                        &nbsp;{tomador.cpfCnpj || ''}
                    </span>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>INSCRIÇÃO ESTADUAL</span>
                        &nbsp;{tomador.inscEstadual || 'ISENTO'}
                    </span>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>PAÍS</span>
                        &nbsp;Brasil
                    </span>
                    <span className='dacte-pessoa-campo'>
                        <span className='dacte-field-label'>FONE</span>
                        &nbsp;{tomador.telefone || ''}
                    </span>
                </div>
            </div>
        );
    }

    exibeProdutoCarga() {
        const { encomenda } = this.props;
        return (
            <div className='dacte-produto-row'>
                <div className='dacte-produto-item'>
                    <div className='dacte-field-label'>PRODUTO PREDOMINANTE</div>
                    <div>{encomenda.descricaoProduto}</div>
                </div>
                <div className='dacte-caracteristicas-item'>
                    <div className='dacte-field-label'>OUTRAS CARACTERÍSTICAS DA CARGA</div>
                    <div>{encomenda.descricaoTipoCalculo}</div>
                </div>
                <div className='dacte-valor-merc-item'>
                    <div className='dacte-field-label'>VALOR TOTAL DA MERCADORIA</div>
                    <div className='dacte-valor-destaque'>{encomenda.valorEncomenda || encomenda.valor}</div>
                </div>
            </div>
        );
    }

    exibePesos() {
        const { encomenda } = this.props;

        if (encomenda.tipoCalculo == 'VALOR_POR_METRO_CUBICO') {
            return (
                <div className='dacte-pesos-row'>
                    <div className='dacte-peso-item'>
                        <div className='dacte-field-label'>PESO BRUTO (KG)</div>
                        <div>{encomenda.pesoBruto}</div>
                    </div>
                    <div className='dacte-peso-item'>
                        <div className='dacte-field-label'>PESO CUBADO</div>
                        <div>{encomenda.pesoCubado}</div>
                    </div>
                    <div className='dacte-peso-item'>
                        <div className='dacte-field-label'>PESO AFERIDO/TAXADO (KG)</div>
                        <div></div>
                    </div>
                    <div className='dacte-peso-item'>
                        <div className='dacte-field-label'>CUBAGEM (M³)</div>
                        <div>{encomenda.volumeTotalMetroCubico}</div>
                    </div>
                    <div className='dacte-peso-item'>
                        <div className='dacte-field-label'>QUANTIDADE DE VOLUMES (UND)</div>
                        <div>{encomenda.volume}</div>
                    </div>
                </div>
            );

        }

        return (
            <div className='dacte-pesos-row'>
                <div className='dacte-peso-item'>
                    <div className='dacte-field-label'>PESO BRUTO (KG)</div>
                    <div>{encomenda.peso}</div>
                </div>
                <div className='dacte-peso-item'>
                    <div className='dacte-field-label'>PESO CUBADO</div>
                    <div></div>
                </div>
                <div className='dacte-peso-item'>
                    <div className='dacte-field-label'>PESO AFERIDO/TAXADO (KG)</div>
                    <div></div>
                </div>
                <div className='dacte-peso-item'>
                    <div className='dacte-field-label'>CUBAGEM (M³)</div>
                    <div></div>
                </div>
                <div className='dacte-peso-item'>
                    <div className='dacte-field-label'>QUANTIDADE DE VOLUMES (UND)</div>
                    <div>{encomenda.volume}</div>
                </div>
            </div>
        );
    }

    exibeComponentesValor() {
        const { encomenda } = this.props;
        return (
            <>
                <div className='dacte-section-title'>COMPONENTES DO VALOR DA PRESTAÇÃO DO SERVIÇO</div>
                <div className='dacte-componentes-row'>
                    <div className='dacte-comp-nome-valor'>
                        <div className='dacte-field-label'>NOME</div>
                        <div>FRETE PESO</div>
                    </div>
                    <div className='dacte-comp-nome-valor'>
                        <div className='dacte-field-label'>VALOR</div>
                        <div>{encomenda.fretePeso}</div>
                    </div>
                    <div className='dacte-comp-nome-valor'>
                        <div className='dacte-field-label'>NOME</div>
                        <div>OUTRAS TAXAS</div>
                    </div>
                    <div className='dacte-comp-nome-valor'>
                        <div className='dacte-field-label'>VALOR</div>
                        <div>{encomenda.outrasTaxas}</div>
                    </div>
                    <div className='dacte-comp-nome-valor'>
                        <div className='dacte-field-label'>NOME</div>
                        <div>AD VALOREM</div>
                    </div>
                    <div className='dacte-comp-nome-valor'>
                        <div className='dacte-field-label'>VALOR</div>
                        <div>{encomenda.adValorem}</div>
                    </div>
                    <div className='dacte-comp-total'>
                        <div className='dacte-field-label'>VALOR TOTAL DA<br />PRESTAÇÃO DO SERVIÇO</div>
                        <div className='dacte-valor-destaque'>{encomenda.valorTotal}</div>
                    </div>
                    <div className='dacte-comp-receber'>
                        <div className='dacte-field-label'>VALOR A RECEBER</div>
                        <div className='dacte-valor-destaque'>{encomenda.valorTotal}</div>
                    </div>
                </div>
            </>
        );
    }

    exibeImpostos() {
        const { encomenda } = this.props;
        return (
            <>
                <div className='dacte-section-title'>INFORMAÇÕES RELATIVAS AO IMPOSTO</div>
                <div className='dacte-impostos-row'>
                    <div className='dacte-imposto-classificacao'>
                        <div className='dacte-field-label'>CLASSIFICAÇÃO TRIBUTÁRIA DO SERVIÇO</div>
                        <div>{encomenda.ultimoHistoricoEmissaoCte && encomenda.ultimoHistoricoEmissaoCte.motivo}</div>
                    </div>
                    <div className='dacte-imposto-item'>
                        <div className='dacte-field-label'>BASE DE CALCULO</div>
                        <div>{encomenda.valorTotal}</div>
                    </div>
                    <div className='dacte-imposto-item'>
                        <div className='dacte-field-label'>ALÍQ ICMS</div>
                        <div>{encomenda.aliquotaICMS}</div>
                    </div>
                    <div className='dacte-imposto-item'>
                        <div className='dacte-field-label'>VALOR ICMS</div>
                        <div>{encomenda.valorICMS}</div>
                    </div>
                    <div className='dacte-imposto-item'>
                        <div className='dacte-field-label'>% RED. BC ICMS</div>
                        <div></div>
                    </div>
                </div>
                <div className='dacte-impostos-row dacte-impostos-row-ibscbs'>
                    <div className='dacte-imposto-item'>
                        <div className='dacte-field-label'>ALÍQ IBS-UF</div>
                        <div>{encomenda.aliquotaIBSUF}</div>
                    </div>
                    <div className='dacte-imposto-item'>
                        <div className='dacte-field-label'>VALOR IBS-UF</div>
                        <div>{encomenda.valorIBSUF}</div>
                    </div>
                    <div className='dacte-imposto-item'>
                        <div className='dacte-field-label'>ALÍQ IBS-MUN</div>
                        <div>{encomenda.aliquotaIBSMun}</div>
                    </div>
                    <div className='dacte-imposto-item'>
                        <div className='dacte-field-label'>VALOR IBS-MUN</div>
                        <div>{encomenda.valorIBSMun}</div>
                    </div>
                    <div className='dacte-imposto-item'>
                        <div className='dacte-field-label'>ALÍQ CBS</div>
                        <div>{encomenda.aliquotaCBS}</div>
                    </div>
                    <div className='dacte-imposto-item'>
                        <div className='dacte-field-label'>VALOR CBS</div>
                        <div>{encomenda.valorCBS}</div>
                    </div>
                </div>
            </>
        );
    }

    exibeDocumentosOriginarios() {
        const { encomenda } = this.props;
        const chaveNfe = encomenda.chaveNfe || '';
        const emitente = encomenda.emitenteCteAnterior || {};
        const cnpjEmitente = emitente.cpjCnpj || encomenda.remetente && encomenda.remetente.cpfCnpj || '';
        return (
            <>
                <div className='dacte-section-title'>DOCUMENTOS ORIGINÁRIOS</div>
                <div className='dacte-docs-header-row'>
                    <div className='dacte-doc-col-tipo dacte-field-label'>TIPO</div>
                    <div className='dacte-doc-col-cnpj dacte-field-label'>CNPJ</div>
                    <div className='dacte-doc-col-chave dacte-field-label'>CHAVE/NÚMERO</div>
                    <div className='dacte-doc-col-tipo dacte-field-label'>TIPO</div>
                    <div className='dacte-doc-col-cnpj dacte-field-label'>CNPJ</div>
                    <div className='dacte-doc-col-chave dacte-field-label'>CHAVE/NÚMERO</div>
                </div>
                {chaveNfe ? (
                    <div className='dacte-docs-data-row'>
                        <div className='dacte-doc-col-tipo'>NFE</div>
                        <div className='dacte-doc-col-cnpj'>{cnpjEmitente}</div>
                        <div className='dacte-doc-col-chave'>{chaveNfe}</div>
                        <div className='dacte-doc-col-tipo'></div>
                        <div className='dacte-doc-col-cnpj'></div>
                        <div className='dacte-doc-col-chave'></div>
                    </div>
                ) : (
                    <div className='dacte-docs-data-row'>
                        <div className='dacte-doc-col-tipo'></div>
                        <div className='dacte-doc-col-cnpj'></div>
                        <div className='dacte-doc-col-chave'></div>
                        <div className='dacte-doc-col-tipo'></div>
                        <div className='dacte-doc-col-cnpj'></div>
                        <div className='dacte-doc-col-chave'></div>
                    </div>
                )}
                <div className='dacte-docs-empty-space'></div>
            </>
        );
    }

    exibeFluxoCarga() {
        const { encomenda } = this.props;
        const endRem = encomenda.enderecoRemetente || {};
        const endDest = encomenda.enderecoDestinatario || {};
        return (
            <>
                <div className='dacte-section-title'>PREVISÃO DO FLUXO DA CARGA</div>
                <div className='dacte-fluxo-row'>
                    <div className='dacte-fluxo-item'>
                        <div className='dacte-field-label'>SIGLA OU CÓDIGO INT. DA FILIAL/PORTO/ESTAÇÃO/AEROPORTO DE ORIGEM</div>
                        <div>{endRem.localidade ? `${endRem.localidade} - ${endRem.uf}` : ''}</div>
                    </div>
                    <div className='dacte-fluxo-item'>
                        <div className='dacte-field-label'>SIGLA OU CÓDIGO INT. DA FILIAL/PORTO/ESTAÇÃO/AEROPORTO DE PASSAGEM</div>
                        <div></div>
                    </div>
                    <div className='dacte-fluxo-item'>
                        <div className='dacte-field-label'>SIGLA OU CÓDIGO INT. DA FILIAL/PORTO/ESTAÇÃO/AEROPORTO DE DESTINO</div>
                        <div>{endDest.localidade ? `${endDest.localidade} - ${endDest.uf}` : ''}</div>
                    </div>
                </div>
            </>
        );
    }

    exibeObsEFisco() {
        const { encomenda } = this.props;
        return (
            <div className='dacte-obs-fisco-row'>
                <div className='dacte-obs-item'>
                    <div className='dacte-field-label'>OBSERVAÇÕES</div>
                    <div>{encomenda.observacao}</div>
                </div>
                <div className='dacte-uso-exclusivo-item'>
                    <div className='dacte-field-label'>USO EXCLUSIVO DO EMISSOR DO CT-E</div>
                </div>
                <div className='dacte-reservado-fisco-item'>
                    <div className='dacte-field-label'>RESERVADO AO FISCO</div>
                </div>
            </div>
        );
    }

    exibeModalRodoviario() {
        const { encomenda } = this.props;
        return (
            <>
                <div className='dacte-section-title'>DADOS ESPECÍFICOS DO MODAL RODOVIÁRIO - CARGA FRACIONADA</div>
                <div className='dacte-modal-rod-row'>
                    <div className='dacte-modal-rod-item'>
                        <div className='dacte-field-label'>RNTRC DA EMPRESA</div>
                        <div>{encomenda.rntrc}</div>
                    </div>
                    <div className='dacte-modal-rod-item'>
                        <div className='dacte-field-label'>DATA PREVISTA DE ENTREGA</div>
                        <div>{encomenda.dataHoraChegada
                            ? <Moment parse='DD/MM/YYYY HH:mm' format='DD/MM/YYYY'>{encomenda.dataHoraChegada}</Moment>
                            : ''}
                        </div>
                    </div>
                    <div className='dacte-modal-rod-legislacao'>
                        <div>ESTE CONHECIMENTO DE TRANSPORTE ATENDE</div>
                        <div>À LEGISLAÇÃO DE TRANSPORTE RODOVIÁRIO EM VIGOR</div>
                    </div>
                    <div className='dacte-modal-rod-item'>
                        <div className='dacte-field-label'>EMISSOR</div>
                        <div>{encomenda.nomeVendedor}</div>
                    </div>
                </div>
            </>
        );
    }

    exibeCabecalho() {
        const { encomenda } = this.props;
        const chaveCte = encomenda.ultimoHistoricoEmissaoCte && encomenda.ultimoHistoricoEmissaoCte.chaveCte;
        const dest = encomenda.destinatario || {};
        return (
            <div className='dacte-stub'>
                <div className='dacte-stub-titulo'>
                    DECLARO QUE RECEBI OS VOLUMES DESTE CONHECIMENTO EM PERFEITO ESTADO PELO QUE DOU POR CUMPRIDO O PRESENTE CONTRATO DE TRANSPORTE
                </div>
                <div className='dacte-stub-row1'>
                    <div className='dacte-stub-cell'>
                        <div className='dacte-field-label'>DATA / HORA</div>
                    </div>
                    <div className='dacte-stub-cell'>
                        <div className='dacte-field-label'>DEST.: {dest.nome}</div>
                    </div>
                    <div className='dacte-stub-cell'>
                        <div className='dacte-field-label'>NOME COMPLETO DO RECEBEDOR</div>
                    </div>
                    <div className='dacte-stub-cte'>
                        <div className='dacte-stub-cte-label'>CT-E</div>
                        <div className='dacte-stub-cte-num'>{encomenda.numeroCte} - {encomenda.serieCte}</div>
                    </div>
                </div>
                <div className='dacte-stub-row2'>
                    <div className='dacte-stub-cell'>
                        <div className='dacte-field-label'>RG/CPF</div>
                    </div>
                    <div className='dacte-stub-cell'></div>
                    <div className='dacte-stub-cell dacte-stub-assinatura'>
                        <div className='dacte-field-label'>ASSINATURA DO RECEBEDOR</div>
                    </div>
                    <div className='dacte-stub-barcode'>
                        {chaveCte ? this.exibeBarcode(chaveCte) : ''}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { encomenda } = this.props;
        return (
            <div id="notaFiscalCteOs" className="dacte-container">
                <div className="dacte-body">
                    {this.exibeParte1()}
                    {this.exibeChaveAcesso()}
                    {this.exibeProtocoloECfop()}
                    {this.exibePessoaSection('REMETENTE', encomenda.remetente, encomenda.enderecoRemetente)}
                    {this.exibePessoaSection('DESTINATÁRIO', encomenda.destinatario, encomenda.enderecoDestinatario)}
                    {this.exibeExpedidorRecebedor()}
                    {this.exibeTomador()}
                    {this.exibeProdutoCarga()}
                    {this.exibePesos()}
                    {this.exibeComponentesValor()}
                    {this.exibeImpostos()}
                    {this.exibeDocumentosOriginarios()}
                    {this.exibeFluxoCarga()}
                    {this.exibeObsEFisco()}
                    {this.exibeModalRodoviario()}
                    <hr style={{ borderTop: '2px dashed', margin: '10px 0' }} />
                    {this.exibeCabecalho()}
                </div>
            </div>
        );
    }
}

export const mapStateToProps = state => {
    return {
        empresaSelecionada: state.empresaSelecionada,
        encomenda: state.encomenda
    }
};

export default withRouter(connect(mapStateToProps, {})(NotaFiscalCte));
